import api from './client'
import type { Attachment } from '../types'

export function getAttachmentFileUrl(fileUrl: string): string {
  try {
    const url = new URL(fileUrl, window.location.origin)
    const uploadPathIndex = url.pathname.indexOf('/api/uploads/')

    if (uploadPathIndex === -1) {
      return fileUrl
    }

    const uploadPath = url.pathname.slice(uploadPathIndex)
    const apiBase = (api.defaults.baseURL || '/api').replace(/\/$/, '')
    const serverBase = apiBase.endsWith('/api') ? apiBase.slice(0, -4) : apiBase

    return serverBase.startsWith('http') ? `${serverBase}${uploadPath}` : uploadPath
  } catch {
    return fileUrl
  }
}

export const attachmentsApi = {
  listAttachments: (issueId: string) =>
    api.get<{ data: Attachment[] }>(`/issues/${issueId}/attachments`),

  uploadAttachment: (issueId: string, file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return api.post<{ data: Attachment }>(`/issues/${issueId}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  deleteAttachment: (issueId: string, attachmentId: string) =>
    api.delete(`/issues/${issueId}/attachments/${attachmentId}`),
}
